import React from 'react'
import './ErrorPopup.css'

// Define the type for the props
interface ErrorPopupProps {
  message: string
  removeError: () => void
}

export const ErrorPopup: React.FC<ErrorPopupProps> = ({ message, removeError }) => {
  return (
    <div className="error-popup">
      <button type="button" className="close-button" onClick={removeError}>
        <div className="icon close"></div>
      </button>
      {message}
    </div>
  )
}
